module.exports = __webpack_public_path__ + "static/media/main idea.ea1336af.mp3";